import axios from "axios";
import { useEffect, useState } from "react"
import { useAuthStore } from "../context/AuthContext";

export interface Company {
  id: number;
  name: string;
}

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

export const useCompanies = () => {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        setLoading(true);
        const companies = await axios.get<Company[]>(`${BACKEND_URL}/companies`).then(res => res.data);
        setCompanies(companies);
      } catch (error) {
        setError(error as Error);
      } finally {
        setLoading(false);
      }
    }

    if (isAuthenticated) {
      fetchCompanies();
    }
  }, [isAuthenticated]);

  return { companies, loading, error }
}
